"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTableBody = exports.ReadingColTh = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.ReadingColTh = styled_components_1.default.th(function (_a) {
    var mediaQueries = _a.theme.mediaQueries;
    return "\n    width: 40%;\n\n    ".concat(mediaQueries.smallAndUp, " {\n      width: auto;\n    }\n  ");
});
exports.StyledTableBody = styled_components_1.default.tbody(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  tr:last-child > td {\n    border-width: 0;\n  }\n"], ["\n  tr:last-child > td {\n    border-width: 0;\n  }\n"])));
var templateObject_1;
